// extracted by mini-css-extract-plugin
export default {"stickySection":"MkqtnGs5I66SD9rNboFD","stickyItemWrapper":"D_bagll7ouji6I7KVBJA","dark":"W9nvC_lyMVEFwuIIIrCE"};